import './main';

document.addEventListener('DOMContentLoaded', function () {
    var menuLetters = document.querySelectorAll('.dictionary-list-header__menu-letter');
    var letterGroups = document.querySelectorAll('.dictionary-list__letter-group');

    menuLetters.forEach(function (letter) {
        letter.addEventListener('click', function (event) {
            var selectedLetter = this.getAttribute('data-letter');
            filterByLetter(selectedLetter);
        });
    });

    function hideMenuLetters() {
        menuLetters.forEach(function (menuLetter) {
            var letter = menuLetter.getAttribute('data-letter');
            var letterFound = false;

            letterGroups.forEach(function (group) {
                if (group.id === 'letter-' + letter && group.classList.contains('show')) {
                    letterFound = true;
                }
            });

            if (letterFound) {
                menuLetter.classList.add('show');
                menuLetter.classList.remove('hide');
            } else {
                menuLetter.classList.remove('show');
                menuLetter.classList.add('hide');
            }
        });
    }

    function filterByLetter(letter) {
        letterGroups.forEach(function (group) {
            if (!group.classList.contains('hide')) {
                if (group.id === 'letter-' + letter) {
                    group.classList.add('active');
                } else {
                    group.classList.remove('active');
                }
            }
        });

        var targetElement = document.getElementById('letter-' + letter);
        if (targetElement && !targetElement.classList.contains('hide')) {
            var offsetTop = targetElement.offsetTop;
            window.scrollTo({
                top: offsetTop + 100,
                behavior: 'smooth'
            });
        }

        menuLetters.forEach(function (menuLetter) {
            if (!menuLetter.classList.contains('hide')) {
                if (menuLetter.getAttribute('data-letter') === letter) {
                    menuLetter.classList.add('active');
                } else {
                    menuLetter.classList.remove('active');
                }
            }
        });
    }

    var searchInput = document.getElementById('search-input');

    searchInput.addEventListener('input', function () {
        var searchValue = this.value.trim().toUpperCase();

        document.querySelectorAll('.main .active').forEach(e => {
            e.classList.remove('active');
        })

        letterGroups.forEach(function (group) {
            var entries = group.querySelectorAll('.dictionary-list__entry');
            var anyMatch = false;

            entries.forEach(function (entry) {
                var entryText = entry.textContent.toUpperCase();

                if (entryText.includes(searchValue)) {
                    entry.classList.remove('hide');
                    entry.classList.add('show');
                    anyMatch = true;
                } else {
                    entry.classList.remove('show');
                    entry.classList.add('hide');
                }
            });

            var shownEntries = group.querySelectorAll('.show');

            if (anyMatch) {
                group.classList.remove('hide');
                group.classList.add('show');
            } else {
                group.classList.remove('show');
                group.classList.add('hide');
            }
        });

        var visibleGroups = document.querySelectorAll('.dictionary-list__letter-group.show');

        var previousFirst = document.querySelector('.first-show');
        var previousLast = document.querySelector('.last-show');

        if (previousFirst) {
            previousFirst.classList.remove('first-show');
        }

        if (previousLast) {
            previousLast.classList.remove('last-show');
        }

        if (visibleGroups.length > 0) {
            visibleGroups[0].classList.add('first-show');
        }

        if (visibleGroups.length > 1) {
            visibleGroups[visibleGroups.length - 1].classList.add('last-show');
        }

        hideMenuLetters();
    });
});
